module.exports = __webpack_public_path__ + "img/img36.3e9a1824.png";